import { PlusOutlined } from '@ant-design/icons'
import { ChangeEvent, useEffect, useMemo, useState } from 'react'
import {
  AddressWithId,
  Address,
  CustomersFilter,
  Customer
} from '../../../entities'
import useCustomers from '../../../services/queries/customer/useCustomers'
import { formatCurrency } from '../../../utils/format/currencyFormat'
import { Button } from '../Button'
import { Card } from '../Card'
import { Col } from '../Col'
import { Divider } from '../Divider'
import { Select } from '../Select'
import { Title } from '../Title'
import { Select as AntdSelect } from 'antd'
import useCustomerAddresses from '../../../services/queries/customer/useCustomerAddresses'
import useProducts from '../../../services/queries/product/useProducts'
import useOpportunityConcepts from '../../../services/queries/opportunity/useOpportunityConcepts'
import useOpportunityEvents from '../../../services/queries/opportunity/useOpportunityEvents'
import usePaymentMethods from '../../../services/queries/order/usePaymentMethod'
import { DatePicker } from '../DatePicker'
import useCustomerCreate from '../../../services/mutations/useCutomerCreate'
import { v4 } from 'uuid'
import { CustomerToSave } from '../../../entities/customerToSave'
import useBusinessUnits from '../../../services/queries/useBusinesUnits'
import Modal from 'antd/lib/modal/Modal'
import { Input } from '../Input'
import { handleChange } from '../../../utils/handleChange'
import { AddressForm } from '../AddressForm'
import { Table } from '../Table'
import { Row } from '../Row'
import { colors } from '../../theme'
import { TextArea } from '../TextArea'
import { useDebounce } from '../../hooks'
import { Product } from '../../../entities/product'
import { useLocation } from 'react-router-dom'
import { routesConfig } from '../../configs/routes'
import { phoneFormat } from '../../../utils/format/phoneFormat'
import usePriceTables from '../../../services/queries/order/usePriceTables'

const { Option } = AntdSelect
//TODO extrair novo cliente para componente separado
const pagination = {
  page: 1,
  limit: 99
}
const contactDefaultValues = {
  name: '',
  role: '',
  phoneNumber: '',
  cellNumber: '',
  email: '',
  observation: '',
  gender: ''
}

const customerDefaultValue = {
  name: '',
  nickname: '',
  employerNumber: '',
  registrationNumber: '',
  businessUnitId: '',
  customerTypeId: '',
  birthday: '',
  addresses: [],
  contacts: []
}

const addressDefaultValues = {
  type: '',
  address: '',
  number: '',
  district: '',
  complement: '',
  zipCode: '',
  city: '',
  state: ''
}

const OrderColumns = [
  {
    title: 'Cod Produto',
    dataIndex: 'id'
  },
  {
    title: 'Descrição',
    dataIndex: 'name'
  },
  {
    title: 'Preço',
    dataIndex: 'price',
    render: (value: any) => formatCurrency(value)
  }
]

const NewClientModal = ({
  isNewClientModalVisible,
  handleNewClientOk,
  handleNewClientCancel,
  form,
  setForm,
  addressForm,
  setAddressForm,
  setFormState
}: any) => {
  const { data, isLoading } = useBusinessUnits({ page: 1, limit: 99 })
  // const handleMobileChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   setForm((prev: any) => ({
  //     ...prev,
  //     cellNumber: phoneFormat(e.target.value)
  //   }))
  // }
  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    setForm((prev: any) => ({
      ...prev,
      phoneNumber: phoneFormat(e.target.value)
    }))
  }
  return (
    <>
      <Modal
        title="Novo Cliente"
        visible={isNewClientModalVisible}
        // onOk={handleNewClientOk}
        onCancel={handleNewClientCancel}
        okText="Cadastrar"
        cancelText="Cancelar"
        centered
        style={{ zIndex: 999 }}
        footer={[
          <Button key="back" onClick={handleNewClientCancel}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" onClick={handleNewClientOk}>
            Cadastrar
          </Button>
        ]}
      >
        <div>
          <Input
            label="Nome"
            value={form?.name}
            onChange={(e) => handleChange(e, 'name', setForm)}
          />
          <Select
            label="Unidade de Negócio"
            value={form?.businessUnitId}
            showSearch
            loading={isLoading}
            filterOption={(input, option) =>
              option?.children.toUpperCase().indexOf(input.toUpperCase()) >= 0
            }
            onSelect={(businessUnitId) =>
              setForm((prev: any) => ({ ...prev, businessUnitId }))
            }
          >
            {data?.data?.map((bu) => (
              <Option key={bu.id} value={bu.id}>
                {`${bu.id} - ${bu.name}`}
              </Option>
            ))}
          </Select>
          <Input
            label="Telefone 1"
            value={form?.phoneNumber}
            onChange={handlePhoneChange}
          />
          <Input
            label="Telefone 2"
            value={form?.cellNumber}
            onChange={handlePhoneChange}
          />
          <Title>Endereço de Instalação</Title>
          <AddressForm
            value={addressForm}
            setValue={setAddressForm}
            setFormState={setFormState}
          />
        </div>
      </Modal>
    </>
  )
}

export const OpportunityForm = (props: any) => {
  const { values, setValues } = props
  const [filters, setFilters] = useState<CustomersFilter>({
    search: values?.opportunity?.customerId
  })
  const [addressForm, setAddressForm] = useState<Address>(addressDefaultValues)
  const [formState, setFormState] = useState<Address>(addressDefaultValues)
  const [isOrderVisible, setIsOrderVisible] = useState<boolean>(false)
  const [isNewClientModalVisible, setIsNewModalVisible] = useState(false)
  const [customerForm, setCustomerForm] =
    useState<CustomerToSave>(customerDefaultValue)
  const [addresses, setAddresses] = useState<AddressWithId[]>([])
  const debouncedSearchTerm = useDebounce(filters.search, 500)
  const location = useLocation()
  const disableCustomer = useMemo(
    () =>
      location.pathname === routesConfig.oportunities.oportunity.create ||
      location.pathname.includes(routesConfig.oportunities.oportunity.details),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(() => {
    if (values?.order?.paymentMethodId && values?.order?.items?.length)
      setIsOrderVisible(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.order?.paymentMethodId, values?.order.items])

  const {
    data: customers,
    isLoading,
    isFetching
  } = useCustomers({
    page: 1,
    limit: 99,
    filters: { ...filters, search: debouncedSearchTerm }
  })
  const { data: queryAddresses, isLoading: isAddressesLoading }: any =
    useCustomerAddresses({
      ...pagination,
      id: values?.opportunity?.customerId
    })

  const { data: products, isLoading: isProductsLoading } = useProducts({
    page: 1,
    limit: 999,
    filters: {
      priceTableId: values.order.priceTableId
    }
  })

  const { data: concepts, isLoading: isConceptsLoading } =
    useOpportunityConcepts({
      ...pagination
    })
  const { data: events, isLoading: isEventsLoading } = useOpportunityEvents({
    ...pagination
  })
  const { paymentMethods, paymentMethodsisLoading } = usePaymentMethods({
    page: 1,
    limit: 999
  })

  const { mutateAsync: customerMutate } = useCustomerCreate()

  const showOrder = () => {
    setIsOrderVisible(true)
  }

  const handleChange = (value: any[]) => {
    setValues((draft: any) => {
      draft.order.items = products?.data?.filter((item) =>
        value.includes(item.id)
      )
    })
  }

  const showNewClientModal = () => {
    setIsNewModalVisible(true)
  }

  const handleNewClientOk = async () => {
    const newAddresses = [
      {
        ...addressForm,
        type: 'PRINCIPAL',
        zipCode: Number(String(addressForm.zipCode).replace(/\D/g, ''))
      },
      {
        ...addressForm,
        type: 'INSTALACAO',
        zipCode: Number(String(addressForm.zipCode).replace(/\D/g, ''))
      }
    ]

    const payload = {
      ...customerForm,
      contacts: [
        {
          ...contactDefaultValues,
          name: customerForm?.name,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          cellNumber: customerForm?.cellNumber.replace(/\D/g, '')
        }
      ],
      addresses: newAddresses
    }

    const customerID: any = await customerMutate(payload)

    setValues((draft: any) => {
      draft.opportunity.customerId = customerID?.data || ''
      draft.order.customerId = customerID?.data || ''
    })
    setFilters({ search: customerForm?.name })
    setIsNewModalVisible(false)
    setCustomerForm(customerDefaultValue)
  }

  const handleNewClientCancel = () => {
    setIsNewModalVisible(false)
  }

  useEffect(() => {
    const addrs = queryAddresses?.data?.map((item: Address) => ({
      ...item,
      id: v4()
    }))
    setAddresses(addrs)
    console.log(addrs)
    setValues((draft: any) => {
      draft.temp.address = addrs?.[0]?.id
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryAddresses])

  useEffect(() => {
    const customer: any = customers?.data?.find(
      (item: Customer) => item.id === values.opportunity?.customerId
    )

    setValues((draft: any) => {
      draft.opportunity.businessUnityId = customer?.businessUnity?.id
      draft.order.businessUnitId = customer?.businessUnity?.id
      draft.order.priceTableId = customer?.priceTableId?.id?.trim()
        ? customer?.priceTableId?.id
        : 'PADRAO'
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, isLoading])

  return (
    <>
      <Title>Informações Gerais</Title>
      <Card>
        <Col>
          <Select
            label="Cliente"
            loading={isLoading || isFetching}
            filterOption={false}
            disabled={!disableCustomer}
            onChange={() => {
              setValues((draft: any) => {
                draft.order.items = []
                draft.temp.address = ''
              })
            }}
            showSearch
            onSearch={(name) => {
              setFilters((prev) => ({
                ...prev,
                search: name.toUpperCase()
              }))
            }}
            value={values?.opportunity?.customerId || null}
            onSelect={(customerId, customer) => {
              setValues((draft: any) => {
                draft.opportunity.customerId = customerId
              })
            }}
            dropdownStyle={{ zIndex: 1 }}
            dropdownRender={(menu) => (
              <div>
                {menu}
                <Divider style={{ margin: '4px 0' }} />
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    padding: 8
                  }}
                >
                  <Button
                    type="primary"
                    onClick={showNewClientModal}
                    style={{ width: '100%' }}
                  >
                    <PlusOutlined /> Novo
                  </Button>
                </div>
                <NewClientModal
                  isNewClientModalVisible={isNewClientModalVisible}
                  handleNewClientOk={handleNewClientOk}
                  handleNewClientCancel={handleNewClientCancel}
                  form={customerForm}
                  setForm={setCustomerForm}
                  addressForm={addressForm}
                  setAddressForm={setAddressForm}
                  formState={formState}
                  setFormState={setFormState}
                />
              </div>
            )}
          >
            {customers?.data?.map((customer) => (
              <Option key={customer.id} value={customer.id}>
                {`${customer.name} - ${customer.id}`}
              </Option>
            ))}
          </Select>
        </Col>
        <Col>
          <Select
            label="Endereço"
            loading={isAddressesLoading}
            value={values?.temp?.address || null}
            onSelect={(address) =>
              setValues((draft: any) => {
                draft.temp.address = address
              })
            }
          >
            {addresses?.map((addr: any) => (
              <Option key={addr.id} value={addr.id}>
                {`(${addr.type || ''}) ${addr.address || ''},
                ${addr.number || ''} - ${addr.district || ''} - ${addr.city}/${
                  addr.state || ''
                }`}
              </Option>
            ))}
          </Select>
        </Col>
        <Col>
          <Input
            label="Contato"
            value={values?.opportunity?.contact}
            onChange={(e) =>
              setValues((draft: any) => {
                draft.opportunity.contact = e.target.value.toUpperCase()
              })
            }
          />
        </Col>
        <Col>
          <Select
            label="Evento"
            allowClear
            loading={isEventsLoading}
            value={values?.opportunity?.eventId || null}
            onSelect={(eventId) =>
              setValues((draft: any) => {
                draft.opportunity.eventId = eventId
              })
            }
          >
            {events?.data?.map((event) => (
              <Option key={event.id} value={event.id}>
                {`${event.name}`}
              </Option>
            ))}
          </Select>
        </Col>
        <Col>
          <Select
            label="Conceito"
            allowClear
            loading={isConceptsLoading}
            value={values?.opportunity?.conceptId || null}
            onSelect={(conceptId) =>
              setValues((draft: any) => {
                draft.opportunity.conceptId = conceptId
              })
            }
          >
            {concepts?.data?.map((concept) => (
              <Option key={concept.id} value={concept.id}>
                {`${concept.name}`}
              </Option>
            ))}
          </Select>
        </Col>
        <Col>
          <DatePicker
            format={'DD/MM/YYYY HH:mm:ss'}
            showTime
            placeholder="Selecione uma data"
            label="Previsão da Venda"
            value={values?.opportunity?.salesForecast || null}
            onChange={(salesForecast: any) =>
              setValues((draft: any) => {
                draft.opportunity.salesForecast = salesForecast
              })
            }
          />
        </Col>
        <Col>
          <DatePicker
            format={'DD/MM/YYYY HH:mm:ss'}
            showTime
            placeholder="Selecione uma data"
            label="Próximo Contato"
            value={values?.opportunity?.nextContact}
            onChange={(nextContact: any) =>
              setValues((draft: any) => {
                draft.opportunity.nextContact = nextContact
              })
            }
          />
        </Col>
      </Card>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        <h2 style={{ paddingRight: 10 }}>Pedido</h2>
        {!isOrderVisible && (
          <Button
            icon={<PlusOutlined style={{ color: colors.primary }} />}
            type="link"
            style={{ color: colors.text, padding: 0, paddingBottom: 5 }}
            onClick={() => {
              showOrder()
            }}
          >
            Adicionar
          </Button>
        )}
      </div>
      {isOrderVisible && (
        <Card>
          <Select
            label="Forma de Pagamento"
            allowClear
            loading={paymentMethodsisLoading}
            value={values?.order?.paymentMethodId || null}
            onSelect={(paymentMethodId) =>
              setValues((draft: any) => {
                draft.order.paymentMethodId = paymentMethodId
              })
            }
          >
            {paymentMethods?.data?.map((payment) => (
              <Option key={payment.id} value={payment.id}>
                {`${payment.description}`}
              </Option>
            ))}
          </Select>
          {/* <Select
            label="Tabela de Preço"
            allowClear
            loading={priceTableIsLoading}
            value={values?.order?.priceTableId || null}
            onSelect={(priceTableId) =>
              setValues((draft: any) => {
                draft.order.priceTableId = priceTableId
              })
            }
          >
            {priceTables?.data?.map((priceTable) => (
              <Option key={priceTable.id} value={priceTable.id}>
                {`${priceTable.description}`}
              </Option>
            ))}
          </Select> */}
          <TextArea
            label="Observação"
            value={values?.order?.observation}
            rows={4}
            onChange={(e: any) => {
              setValues((draft: any) => {
                draft.order.observation = String(e.target.value).toUpperCase()
              })
            }}
          />
          <Select
            label="Produtos"
            mode="multiple"
            loading={isProductsLoading}
            maxTagTextLength={15}
            placeholder="Selecione"
            value={
              values?.order?.items?.map((item: Product) => item.id) || null
            }
            onChange={handleChange}
          >
            {products?.data?.map((product) => (
              <Option key={product.id} value={product.id}>
                {`${product.id} - ${product.name}`}
              </Option>
            ))}
          </Select>
          <Table
            dataSource={values.order.items}
            columns={OrderColumns}
            bordered
            footer={() => (
              <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Col span={2}>
                  <span style={{ fontSize: 'bold' }}>{'Total:'}</span>
                </Col>
                <Col span={3}>
                  {formatCurrency(
                    values.order.items?.reduce(
                      (acc: any, cur: any) => acc + cur.price,
                      0
                    ) || 0
                  )}
                </Col>
              </Row>
            )}
          />
        </Card>
      )}
    </>
  )
}
